import styled from "styled-components";

export const ModalBackground = styled.div`
  position: absolute;
  width: 564px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 26px; 
  padding: 16px 32px 24px;
  opacity: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px; /* Adiciona um espaço entre os elementos */

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    padding: 16px;
  }

  @media (max-width: 480px) {
    width: 95%;
    height: auto;
    padding: 12px;
    border-radius: 16px;
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalHeader = styled.div`
  align-items: center;
  width: 100%;
  padding: 10px;
`;

export const ModalBody = styled.div`
  padding: 10px;
  width: 100%;
`;


export const ModalText = styled.p`
  font-family: Mangueira;
  font-size: 26.05px;
  line-height: 40.17px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 30px;
    padding: 0 16px;
  }
`;

export const StyledLink = styled.a`
  font-family: Mangueira;
  font-size: 26.05px;
  line-height: 40.17px;
  text-align: center;
  font-weight: 600;
  color: #00e2ff;

  @media (max-width: 480px) {
    font-size: 20px;
    line-height: 30px;
    padding: 0 16px;
  }
`;